var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 8.05581C5.83337 7.46637 6.06753 6.90107 6.48433 6.48427C6.90113 6.06747 7.46643 5.83331 8.05587 5.83331H15.2775C15.5694 5.83331 15.8584 5.8908 16.1281 6.00249C16.3977 6.11418 16.6427 6.27789 16.8491 6.48427C17.0555 6.69065 17.2192 6.93565 17.3309 7.2053C17.4426 7.47495 17.5 7.76395 17.5 8.05581V15.2775C17.5 15.5693 17.4426 15.8583 17.3309 16.128C17.2192 16.3976 17.0555 16.6426 16.8491 16.849C16.6427 17.0554 16.3977 17.2191 16.1281 17.3308C15.8584 17.4425 15.5694 17.5 15.2775 17.5H8.05587C7.76401 17.5 7.47501 17.4425 7.20536 17.3308C6.93571 17.2191 6.69071 17.0554 6.48433 16.849C6.27795 16.6426 6.11424 16.3976 6.00255 16.128C5.89086 15.8583 5.83337 15.5693 5.83337 15.2775V8.05581Z",
    stroke: "#111111",
    strokeOpacity: 0.87,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34333 13.9475C3.08779 13.8018 2.87523 13.5912 2.72715 13.3371C2.57906 13.0829 2.50071 12.7942 2.5 12.5V4.16667C2.5 3.25 3.25 2.5 4.16667 2.5H12.5C13.125 2.5 13.465 2.82083 13.75 3.33333",
    stroke: "#111111",
    strokeOpacity: 0.87,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate_icon.e7065b52df8cc47fcdd5e2f893ea7929.svg";
export { ForwardRef as ReactComponent };